/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateWalletOnePaymentMutationRequest, CreateWalletOnePaymentMutationResponse, CreateWalletOnePayment400, CreateWalletOnePayment401 } from "../entities/CreateWalletOnePayment";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createWalletOnePayment } from "../api/createWalletOnePayment";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createWalletOnePaymentMutationKey = () => [{ url: '/api/v1/payments/wallet-one' }] as const

export type CreateWalletOnePaymentMutationKey = ReturnType<typeof createWalletOnePaymentMutationKey>

export function createWalletOnePaymentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateWalletOnePaymentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createWalletOnePaymentMutationKey()
        return mutationOptions<CreateWalletOnePaymentMutationResponse, ResponseErrorConfig<CreateWalletOnePayment400 | CreateWalletOnePayment401>, {data: CreateWalletOnePaymentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createWalletOnePayment(data, config)
          },
        })

}

/**
 * @description Создает новый платеж для платежной системы WalletOne.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 100 RUB
 * - Максимальная сумма платежа: 9000 RUB
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Создание записи в БД
 * 3. Формирования формы заказа на стороне вебвью
 * 4. Отправка формы заказа в WalletOne API
 * 5. Возврат URL для оплаты
 * @summary Инициализация платежа для WalletOne
 * {@link /api/v1/payments/wallet-one}
 */
export function useCreateWalletOnePayment<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateWalletOnePaymentMutationResponse, ResponseErrorConfig<CreateWalletOnePayment400 | CreateWalletOnePayment401>, {data: CreateWalletOnePaymentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateWalletOnePaymentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createWalletOnePaymentMutationKey()

          const baseOptions = createWalletOnePaymentMutationOptions(config) as UseMutationOptions<CreateWalletOnePaymentMutationResponse, ResponseErrorConfig<CreateWalletOnePayment400 | CreateWalletOnePayment401>, {data: CreateWalletOnePaymentMutationRequest}, TContext>
          

          return useMutation<CreateWalletOnePaymentMutationResponse, ResponseErrorConfig<CreateWalletOnePayment400 | CreateWalletOnePayment401>, {data: CreateWalletOnePaymentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateWalletOnePaymentMutationResponse, ResponseErrorConfig<CreateWalletOnePayment400 | CreateWalletOnePayment401>, {data: CreateWalletOnePaymentMutationRequest}, TContext>
      
}